import { DateTime } from 'luxon';

// pure helper for DebugService.getNowLocal — overlay only fakeNow's date onto realNow's zone (avoids leaking fakeNow's stored fixed offset across DST)
// if fakeNowISO is empty/invalid, return realNow; else replace year/month/day on realNow
export function resolveFakeNow(fakeNowISO: string | null | undefined, realNow: DateTime): DateTime {
  if (!fakeNowISO) return realNow;
  const fake = DateTime.fromISO(fakeNowISO);
  if (!fake.isValid) return realNow;
  return realNow.set({ year: fake.year, month: fake.month, day: fake.day });
}
